import { useLocation, useNavigate } from 'react-router-dom';

import './Navbar.css';

const NavBar = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const navItems = [
        { label: 'Home', path: '/home', icon: 'fa-solid fa-house', activePaths: ['/', '/home'] },
        { label: 'About', path: '/about', icon: 'fa fa-info-circle' },
        { label: 'Skills', path: '/skills', icon: 'fa fa-cogs' },
        { label: 'Contact', path: '/contact', icon: 'fa-solid fa-address-book' },
    ];
    
    return (
        <div id="navbar-container">
            
            <h2>
                <span>NRH</span>
                Nathan R. Heinz
            </h2>

            <div id="navbar-buttons-container">
                {navItems.map(({ label, path, icon, activePaths }) => {
                    const isActive = activePaths ? activePaths.includes(pathname) : pathname === path;

                    return (
                        <button
                            key={path}
                            type="button"
                            className={`navbar-navlink${isActive ? ' navbar-navlink-focus' : ''}`}
                            title={label}
                            aria-current={isActive ? 'page' : undefined}
                            onClick={() => navigate(path)}
                        >
                            <i className={`${icon} nav-icon${isActive ? ' nav-icon-focus' : ''}`} />
                            <span>{label}</span>
                        </button>
                    );
                })}
            </div>
            
        </div>
    );
};

export default NavBar;
